<div class="accordion" id="accordionWarning">
    <div class="card">
        <div class="card-header" id="backupHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#backupCollapse" aria-expanded="true" aria-controls="warningCollapse">
                Backups incomplets <ng-container *ngIf="backups"> <b> ({{backups.length}})</b></ng-container>
            </button>
        </div>
        <div id="backupCollapse" class="panel-collapse collapse show" aria-labelledby="backupHeader"
            data-parent="#accordionWarning">
            <app-gmao-spinner *ngIf="!backups"></app-gmao-spinner>
            <ng-container *ngIf="backups">

                <table class="table table-striped home-table table-sm">
                    <thead>
                        <th scope="col">Numéro de série</th>
                        <th scope="col">Nom de l'installation</th>
                        <th scope="col">Attestation de caisse</th>
                        <th scope="col">Dernière sauvegarde complète</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let backup of backups" (click)="getInstallPage(backup.ID_INSTALLATION)">
                            <td>{{backup.NUMERO_SERIE}}</td>
                            <td>{{backup.NOM_INSTALLATION}}</td>
                            <td>{{backup.VALEUR_CHAMP}}</td>
                            <td>{{getNiceDate(backup.LAST_COMPLETE_SAVE)}}</td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>

        <div class="card-header" id="installsNotInServiceHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#installsNotInServiceCollapse" aria-expanded="true" aria-controls="warningCollapse">
                Installations enregistrant des ventes non mises en service <ng-container *ngIf="installsNotInService">
                   <b> ({{installsNotInService.length}}) </b> </ng-container>
            </button>
        </div>
        <div id="installsNotInServiceCollapse" class="panel-collapse collapse"
            aria-labelledby="installsNotInServiceHeader" data-parent="#accordionWarning">
            <app-gmao-spinner *ngIf="!installsNotInService"></app-gmao-spinner>
            <ng-container *ngIf="installsNotInService">
                <table class="table table-striped home-table table-sm">
                    <thead>
                        <th scope="col">Numéro de série</th>
                        <th scope="col">Nom de l'installation</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let install of installsNotInService"
                            (click)="getInstallPage(install.ID_INSTALLATION)">
                            <td>{{install.NUMERO_SERIE}}</td>
                            <td>{{install.NOM_INSTALLATION}}</td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

        </div>

        <div class="card-header" id="installsNotConnectedHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#installsNotConnectedCollapse" aria-expanded="true" aria-controls="warningCollapse">
                Installations non connectées récemment (30 jours) <ng-container *ngIf="installs">
                  <b>  ({{installs.length}}) </b></ng-container>
            </button>
        </div>
        <div id="installsNotConnectedCollapse" class="panel-collapse collapse"
            aria-labelledby="installsNotConnectedHeader" data-parent="#accordionWarning">

            <app-gmao-spinner *ngIf="!installs"></app-gmao-spinner>
            <ng-container *ngIf="installs">
                <table class="table table-striped home-table table-sm">
                    <thead>
                        <th scope="col">Numéro de série</th>
                        <th scope="col">Nom de l'installation</th>
                        <th scope="col">Dernière connexion</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let install of installs" (click)="getInstallPage(install.ID_INSTALLATION)">
                            <td>{{install.NUMERO_SERIE}}</td>
                            <td>{{install.NOM_INSTALLATION}}</td>
                            <td>{{getNiceDate(install.LAST_TELECOLLECTE)}}</td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </div>
</div>
